import { find, map } from "lodash-es";
import { IServiceDataItem } from "../components/common/FeatureSlider/FeatureSlider";
import FcIcon1x from "../assets/esports/fc_icon_1x.webp";
import FcIcon2x from "../assets/esports/fc_icon_2x.webp";
import FcIcon3x from "../assets/esports/fc_icon_3x.webp";
import Sf5Icon1x from "../assets/esports/sf5_icon_1x.webp";
import Sf5Icon2x from "../assets/esports/sf5_icon_2x.webp";
import Sf5Icon3x from "../assets/esports/sf5_icon_3x.webp";
import FortniteIcon1x from "../assets/esports/fortnite_icon_1x.webp";
import FortniteIcon2x from "../assets/esports/fortnite_icon_2x.webp";
import FortniteIcon3x from "../assets/esports/fortnite_icon_3x.webp";
import CodIcon1x from "../assets/esports/cod_icon_1x.webp";
import CodIcon2x from "../assets/esports/cod_icon_2x.webp";
import CodIcon3x from "../assets/esports/cod_icon_3x.webp";
import PubgIcon1x from "../assets/esports/pubg_icon_1x.webp";
import PubgIcon2x from "../assets/esports/pubg_icon_2x.webp";
import PubgIcon3x from "../assets/esports/pubg_icon_3x.webp";
const SafaricomIcon =
  "https://assets.onmogaming.com/static/gaming-platform/safaricom/safaricom_icon.webp";

export const APP_URL = `${window.location.origin}`;

export const DirectoryTab: Record<string, string> = {
  allServices: "directory_All Services",
  mySubscriptions: "directory_My Subscriptions",
  myFavorites: "directory_My Favorites",
  recentlyPlayed: "directory_Recently Played",
  gameServices: "directory_Game Services",
  allGames: "directory_All Games",
};

export const defaultServiceIcon = [
  {
    title: "My Subscriptions",
    id: "mySubscriptions",
    launchpads: ["ca"],
  },
  {
    title: "Free Games",
    id: "freeGames",
    launchpads: [],
  },
  {
    title: "Casual Games",
    id: "casualGames",
    launchpads: ["playinc"],
  },
  {
    title: "Trivia Games",
    id: "triviaGames",
    launchpads: ["ca", "onmo"],
  },
  {
    title: "eSports",
    id: "eSports",
    launchpads: ["fanclash"],
  },
];

export const defaultServicesList = [
  {
    id: "mySubscriptions",
    title: "My Subscriptions",
    itemType: "vertical",
    enterLink: ["https://challengesarena.com/"],
    description: "Welcome back to Gamehub!",
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/My-Subcription.png",
    sliderItems: [],
  },
  {
    id: "freeGames",
    title: "Free Games",
    itemType: "vertical",
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/Free-Games.png",
    disableIframe: true,
    sliderItems: [
      {
        image:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/Galaxy-Shooters.png",
        video:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/video/Galaxy-Shooters.mp4",
        link: "https://cms.onmostealth.com/games/129/ca?version=ca_1756277041567.js",
        disableIframe: true,
      },
      // {
      //   image:
      //     "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/Basketball.png",
      //   video:
      //     "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/video/Basketball.mp4",
      //   link: "",
      //   disableIframe: true,
      // },
      {
        image:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/Little-Pond.png",
        video:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/video/Little-Pond.mp4",
        link: "https://cms.onmostealth.com/games/126/ca?version=ca_1752207898828.js",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/Fruit-Ninja.png",
        video:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/video/Fruit-Ninja.mp4",
        link: "https://cms.onmostealth.com/games/127/ca?version=ca_1755680041434.js",
        disableIframe: true,
      },
      // {
      //   image:
      //     "https://assets.onmogaming.com/static/gaming-platform/Free-Games/Penalty-Shootout-Masters.png",
      //     video:
      // "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/video/Penality-Shooter.mp4",
      //   link: "",
      //   disableIframe: true,
      // },
      {
        image:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/Viral-Tap.png",
        video:
          "https://assets.onmogaming.com/static/gaming-platform/Vodacom/free-games/video/Viral-Tap.mp4",
        link: "https://cms.onmostealth.com/games/128/ca?version=ca_1755167799739.js",
        disableIframe: true,
      },
    ],
  },
  {
    id: "casualGames",
    title: "Casual Games",
    itemType: "vertical",
    enterLink: ["https://playinc.com/"],
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/Casual-Games.png",
    sliderItems: [],
  },
  {
    id: "triviaGames",
    title: "Trivia Games",
    itemType: "vertical",
    enterLink: ["https://challengesarena.com/", "https://play.onmo.com/"],
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/Trival-Game.png",
    sliderItems: [],
  },
  {
    id: "eSports",
    title: "eSports",
    itemType: "vertical",
    enterLink: ["https://chessmasters.co.za/"],
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/eSport-game.png",
    sliderItems: [],
  },
];

const listGame = [
  {
    title: "Fruit Merge",
    partner: ["onmo"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/ONMO/Subway-Surfers.png",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/video/Subway-Surfers.mp4",
    link: "https://gamegoza.com/game/152144",
    isActive: true,
  },
  {
    title: "Cut the Rope",
    partner: ["onmo"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/Cut-The-Rope-Magic.png",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/video/Cut-The-Rope.mp4",
    link: "https://gamegoza.com/game/141753",
    isActive: true,
  },
  {
    title: "Hitman Sniper",
    partner: ["onmo"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/Hitman-Sniper.png",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/video/Hitman-Sniper.mp4",
    link: "https://gamegoza.com/game/13497",
    isActive: true,
  },
  {
    title: "Lara Croft",
    partner: ["onmo"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/Lara-Croft-Relic-Run.png",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/video/LaraCroft-RelicRun.mp4",
    link: "https://gamegoza.com/game/13392",
    isActive: true,
  },
  {
    title: "Gravity Rider",
    partner: ["onmo"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/Gravity-Rider.png",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/onmo/video/Gravity-Raider.mp4",
    link: "https://gamegoza.com/game/13454",
    isActive: true,
  },
  {
    title: "Archery",
    partner: ["ca"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/Archery.webp",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/video/Archery.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/2337938",
    isActive: true,
  },
  {
    title: "Color Sort Mania",
    partner: ["ca"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/Color-Sort-Mania.webp",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/video/Color-Sort-Mania.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/1380616",
    isActive: true,
  },
  {
    title: "Cricket Bash",
    partner: ["ca"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/Cricket-Bash.webp",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/video/Cricket-Bash.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/2337934",
    isActive: true,
  },
  {
    title: "Fruit-Merge",
    partner: ["ca"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/Fruit-Merge.webp",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/video/Fruit-Merge.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/1728762",
    isActive: true,
  },
  {
    title: "Solitiare PRO",
    partner: ["ca"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/Solitiare-PRO.webp",
    video:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/ca/video/Solitaire.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/1380612",
    isActive: true,
  },
  {
    title: "Chess Masters",
    partner: ["fanclash"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/fanclash/chess.webp",
    link: "https://unlock3.co.za/",
    isActive: true,
  },
  {
    title: "Quizinc 2.0",
    partner: ["fanclash"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/fanclash/quiz-head.png",
    link: "https://quizinc.co.za/",
    isActive: true,
  },
  {
    title: "Quiz",
    partner: ["fanclash"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/fanclash/quiz.jpeg",
    link: "https://quizhead2head.co.za/",
    isActive: true,
  },
  {
    title: "Stop The Clock",
    partner: ["fanclash"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/fanclash/stop-clock.png",
    link: "https://stopclock.co.za/",
    isActive: true,
  },
  {
    title: "TapKO",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/tap%20ok.webp",
    link: "https://playinc.com/games/details/TapKO/133812289",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Fish out of water",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/fish%20water.webp",
    link: "https://playinc.com/games/details/Fish-Out-Of-Water/133150012",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Ludo Legend",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/ludo%20legend.webp",
    link: "https://playinc.com/games/details/Ludo-Legend/59819350",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Basketball Master",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/basketball.webp",
    link: "https://playinc.com/games/details/Basketball-Master/58999566",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Coffee Break",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/coffee%20break.webp",
    link: "https://playinc.com/games/details/Coffee-Break-Puzzle/122638352",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Tower Boxer",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/tower%20boxer.webp",
    link: "https://playinc.com/games/details/Tower-Boxer/117796603",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Thor Boss",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/thor.webp",
    link: "https://playinc.com/games/details/Thor-Boss-Battles/94683541",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Color Pin",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/color%20pin.webp",
    link: "https://playinc.com/games/details/Knife-Madness/134053822",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Knife Madness",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/knife%20madness.webp",
    link: "https://playinc.com/games/details/Knife-Madness/134053822",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Garden Block",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/garden%20block.webp",
    link: "https://playinc.com/games/details/Garden-Block-Puzzle/133942955",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Pool Ball",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/pool.webp",
    link: "https://playinc.com/games/details/Pool-8-Ball-Mania/78565600",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Wood Block",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/wood%20block.webp",
    link: "https://playinc.com/games/details/Wood-Block-Puzzle/119117508",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Dots Mania",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/dotsmania.webp",
    link: "https://playinc.com/games/details/Dotsmania/39671867",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Disney Channel - House of haunts",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/disney%20channel.webp",
    link: "https://playinc.com/games/details/Disney-Channel-House-of-Haunts/114242606",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "7x7",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/7x7.webp",
    link: "https://playinc.com/games/details/7x7-Ultimate/49484032",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Halloween Match",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/halloween%20match%203.webp",
    link: "https://playinc.com/games/details/Halloween-Match-3/122675582",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Ben 10",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/ben%2010.webp",
    link: "https://playinc.com/games/details/Ben-10-Power-of-the-Omnitrix/67694219",
    isActive: true,
    disableIframe: true,
  },

  {
    title: "Help the duck",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/help%20duck.webp",
    link: "https://playinc.com/games/details/Help-The-Duck/129374840",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Jumpers quest",
    partner: ["playInc"],
    image:
      "https://assets.onmogaming.com/static/gaming-platform/Vodacom/playinc/jumpers%20quest.webp",
    link: "https://playinc.com/games/details/Jumpers-Quest/133812290",
    isActive: true,
    disableIframe: true,
  },
];

const dataFeatureHomePage =
  // JSON.parse(import.meta.env.VITE_FEATURED_HOMEPAGE_CFG || "null") ||
  defaultServicesList;

export const servicesList = map(defaultServiceIcon, (serviceIcon) => {
  const serviceItem = find(dataFeatureHomePage, {
    title: serviceIcon.title,
  }) as IServiceDataItem;

  const sliderItems = listGame
    .filter((g) => g.isActive === true)
    .filter((g) =>
      g.partner.some((p) => serviceIcon.launchpads.includes(p.toLowerCase())),
    )
    .map((g) => ({
      image: g.image,
      video: g.video,
      link: g.link,
      partner: g.partner,
      disableIframe: g.disableIframe ?? false,
    }));

  return {
    ...serviceIcon,
    ...serviceItem,
    sliderItems: sliderItems.length ? sliderItems : serviceItem?.sliderItems,
  };
});

export const getLinkByServiceId = (
  serviceData: IServiceDataItem,
  selectedService: string,
) => {
  if (!selectedService) return serviceData.enterLink?.[0];
  if (selectedService) {
    const index = serviceData?.launchpads?.indexOf(selectedService) ?? 0;
    return index !== -1 ? serviceData?.enterLink?.[index] : undefined;
  }
};

// The "onmo" subscription is sold under the "gamegoza" service id.
export const resolveServiceId = (productId: string) =>
  productId === "onmo" ? "gamegoza" : productId;

export const getCategoryIcon = (category: string) => {
  switch (category) {
    case "ca":
      return {
        src1x: servicesIcons.caIcon["1x"],
        src2x: servicesIcons.caIcon["2x"],
        src3x: servicesIcons.caIcon["3x"],
      };
    case "gamegoza":
    case "onmo":
      return {
        src1x: servicesIcons.onmoIcon["1x"],
        src2x: servicesIcons.onmoIcon["2x"],
        src3x: servicesIcons.onmoIcon["3x"],
      };
    case "playinc":
      return {
        src1x: servicesIcons.playIncIcon["1x"],
        src2x: servicesIcons.playIncIcon["2x"],
        src3x: servicesIcons.playIncIcon["3x"],
      };
    case "chessmasters":
    case "quizinc":
    case "stopclock":
    case "quizhead2head":
    case "unlock3":
    case "pineappleonpizza":
    case "lunarloops":
    case "firebound":
    case "fanclash":
      return {
        src1x: servicesIcons.fanclashIcon["1x"],
        src2x: servicesIcons.fanclashIcon["2x"],
        src3x: servicesIcons.fanclashIcon["3x"],
      };
    case "safaricom_contest":
    case "safaricom_esports":
    case "safaricom_sports":
    case "safaricom_ca":
    case "safaricom_onmo":
    case "safaricom_kids":
    case "safaricom_trivia":
      return {
        src1x: SafaricomIcon,
        src2x: SafaricomIcon,
        src3x: SafaricomIcon,
      };
  }
};

export const ESPORTS_FEED = {
  video:
    "https://assets.onmogaming.com/static/gaming-platform/Vodacom/esport/BLG_Intro.mp4",
  background:
    "https://assets.onmogaming.com/static/gaming-platform/Vodacom/esport/cover-image.webp",
};

export const ESPORTS_ICON_LIST = [
  {
    id: "fc",
    src1x: FcIcon1x,
    src2x: FcIcon2x,
    src3x: FcIcon3x,
  },
  {
    id: "sf5",
    src1x: Sf5Icon1x,
    src2x: Sf5Icon2x,
    src3x: Sf5Icon3x,
  },
  {
    id: "fortnite",
    src1x: FortniteIcon1x,
    src2x: FortniteIcon2x,
    src3x: FortniteIcon3x,
  },
  {
    id: "cod",
    src1x: CodIcon1x,
    src2x: CodIcon2x,
    src3x: CodIcon3x,
  },
  {
    id: "pubg",
    src1x: PubgIcon1x,
    src2x: PubgIcon2x,
    src3x: PubgIcon3x,
  },
];

const folderPath = `${APP_URL}/themes/images/services`;
const getResponsiveImages = (fileName: string, extension = "webp") => {
  return {
    "1x": `${folderPath}/${fileName}_1x.${extension}`,
    "2x": `${folderPath}/${fileName}_2x.${extension}`,
    "3x": `${folderPath}/${fileName}_3x.${extension}`,
  };
};
export const servicesIcons = {
  caIcon: getResponsiveImages("ca"),
  onmoIcon: getResponsiveImages("onmo"),
  playIncIcon: getResponsiveImages("playinc"),
  fanclashIcon: getResponsiveImages("fanclash"),
};
